import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import RichText from '../RichText';

import { getImageDataWithHttps } from '../../utils/contentful';
import { IFullwidthHero20Fields } from '@/types/contentful';
import Image from 'next/legacy/image';

type AdditionalTextProps = Pick<IFullwidthHero20Fields, 'additionalText'>;

const RICH_TEXT_OVERRIDE: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node, children) => {
    return (
      <p className="whitespace-pre text-left text-xs tablet:text-sm">
        {children}
      </p>
    );
  },
  [BLOCKS.EMBEDDED_ASSET]: (node) => {
    const data = getImageDataWithHttps(node.data.target);
    return (
      <Image
        src={data.src}
        alt={data.alt}
        width={16}
        height={16}
        className="-mt-[1px] mr-1 tablet:mt-[1px]"
      />
    );
  }
};

export const AdditionalText = ({ additionalText }: AdditionalTextProps) => {
  return (
    <div className="col-span-10">
      <div
        className="mt-5 flex max-w-[21rem] flex-row items-start justify-between whitespace-pre text-[14px]"
        data-e2e="additional-content-container"
      >
        <RichText data={additionalText} overrideOptions={RICH_TEXT_OVERRIDE} />
      </div>
    </div>
  );
};
